(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nattaup-cart-assurance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nattaup-cart-assurance')) {
    customElements.define(
      'nattaup-cart-assurance',
      class extends HTMLElement {
        connectedCallback() {
          const cartTotal = Number(this.dataset.cartTotal);
          const thresholdEur = Number(this.dataset.thresholdEur);
          const currency = this.dataset.currency;
          const rate = Number(window.Shopify?.currency?.rate);
          let threshold = thresholdEur;

          if (currency !== 'EUR') {
            if (!Number.isFinite(rate) || rate <= 0) {
              return;
            }

            threshold = Math.round(thresholdEur * rate);
          }

          const remaining = Math.max(0, threshold - cartTotal);
          const progress = Math.min(100, Math.max(0, (cartTotal / threshold) * 100));
          const progressElement = this.querySelector('[data-cart-assurance-progress]');
          const progressValue = this.querySelector('[data-cart-assurance-progress-value]');
          const message = this.querySelector('[data-cart-assurance-message]');

          progressElement.hidden = false;
          progressElement.setAttribute('aria-valuemax', String(threshold));
          progressElement.setAttribute('aria-valuenow', String(Math.min(cartTotal, threshold)));
          progressValue.style.setProperty('--nattaup-cart-progress', `${progress}%`);

          if (remaining === 0) {
            message.textContent = this.dataset.unlocked;
            return;
          }

          let formattedAmount;

          try {
            formattedAmount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency,
            }).format(remaining / 100);
          } catch (error) {
            formattedAmount = `${(remaining / 100).toFixed(2)} ${currency}`;
          }

          message.textContent = this.dataset.awayTemplate.replace('__AMOUNT__', formattedAmount);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
